import { Injectable } from '@angular/core';

@Injectable()
export class TokenStorageService {

  constructor() { }

  signOut(): void {
    window.sessionStorage.clear();
  }

  public saveToken(token: string): void {
    window.sessionStorage.removeItem('access_token');
    window.sessionStorage.setItem('access_token', token);
    // localStorage.removeItem("access_token");
    // localStorage.setItem("access_token", token);
  }

  public getToken(): string{
    return sessionStorage.getItem('access_token');
    // return sessionStorage.getItem(DBkeys.ACCESS_TOKEN);
  }

  public clearSessionStorage(): void {
    // window.localStorage.clear();
    window.sessionStorage.clear();
  }
}
